/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InstagramConnectionResponse } from '../../models/instagram-connection-response';

export interface VerifyInstagramAccount$Params {
}

export function verifyInstagramAccount(http: HttpClient, rootUrl: string, params?: VerifyInstagramAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<InstagramConnectionResponse>> {
  const rb = new RequestBuilder(rootUrl, verifyInstagramAccount.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InstagramConnectionResponse>;
    })
  );
}

verifyInstagramAccount.PATH = '/v1/api/ui/instagram-accounts/verify';
